module.exports = __webpack_public_path__ + "static/media/about-right-patch.446c0005.png";